// This file is generated by a script. Do not edit this file directly.
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { cva } from 'cva';
import { Icon } from "../../components/Icon";
import { cn } from "../utils";
import { Base } from "../../components/Typography/Base";
import { Tooltip } from "../../components/Tooltip/Tooltip";
export var ChoiceGroupDirection = /*#__PURE__*/function (ChoiceGroupDirection) {
  ChoiceGroupDirection["VERTICAL"] = "vertical";
  ChoiceGroupDirection["HORIZONTAL"] = "horizontal";
  return ChoiceGroupDirection;
}({});
export var ChoiceGroupColumns = /*#__PURE__*/function (ChoiceGroupColumns) {
  ChoiceGroupColumns["SingleCol"] = "single-column";
  ChoiceGroupColumns["TwoCol"] = "two-column";
  return ChoiceGroupColumns;
}({});
var groupDirection = cva({
  base: 'cop-flex cop-mt-2',
  variants: {
    direction: _defineProperty(_defineProperty({}, ChoiceGroupDirection.VERTICAL, 'cop-flex-col cop-gap-2'), ChoiceGroupDirection.HORIZONTAL, 'cop-flex-row cop-gap-4')
  },
  defaultVariants: {
    direction: ChoiceGroupDirection.VERTICAL
  }
});
var groupLayout = cva({
  base: 'cop-flex',
  variants: {
    layout: _defineProperty(_defineProperty({}, ChoiceGroupColumns.SingleCol, 'cop-flex-col'), ChoiceGroupColumns.TwoCol, 'cop-flex-row cop-gap-8')
  },
  defaultVariants: {
    layout: ChoiceGroupColumns.SingleCol
  }
});
export var ChoiceGroupLayout = function ChoiceGroupLayout(_ref) {
  var label = _ref.label,
    description = _ref.description,
    error = _ref.error,
    helperText = _ref.helperText,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? ChoiceGroupDirection.VERTICAL : _ref$direction,
    _ref$layout = _ref.layout,
    layout = _ref$layout === void 0 ? ChoiceGroupColumns.SingleCol : _ref$layout,
    children = _ref.children,
    className = _ref.className,
    tooltipProps = _ref.tooltipProps;
  var isSingleColLayout = layout === ChoiceGroupColumns.SingleCol;
  var helperTextRenderer = helperText ? /*#__PURE__*/React.createElement("div", {
    className: "cop-text-secondary"
  }, /*#__PURE__*/React.createElement(Base, {
    variant: "body",
    size: "sm",
    leading: "normal",
    tag: "span",
    weight: "regular"
  }, helperText)) : null;
  return /*#__PURE__*/React.createElement("div", {
    className: cn(className, groupLayout({
      layout: layout
    }))
  }, /*#__PURE__*/React.createElement("div", {
    className: "cop-flex cop-justify-between cop-gap-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cop-flex cop-flex-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cop-flex cop-gap-1"
  }, /*#__PURE__*/React.createElement(Base, {
    variant: "body",
    size: "base",
    leading: "tight",
    tag: "span",
    weight: "medium"
  }, label), tooltipProps && /*#__PURE__*/React.createElement(Tooltip, tooltipProps, /*#__PURE__*/React.createElement(Icon, {
    icon: "Info",
    className: "cop-text-text-primary cop-h-3 cop-w-3"
  }))), description && /*#__PURE__*/React.createElement("div", {
    className: "cop-mt-0.5 cop-text-secondary"
  }, /*#__PURE__*/React.createElement(Base, {
    variant: "body",
    size: "sm",
    leading: "normal",
    tag: "span",
    weight: "regular"
  }, description))), isSingleColLayout && helperTextRenderer), /*#__PURE__*/React.createElement("div", null, !isSingleColLayout && helperTextRenderer, /*#__PURE__*/React.createElement("div", {
    className: cn(groupDirection({
      direction: direction
    }))
  }, children), error && /*#__PURE__*/React.createElement("div", {
    className: "cop-mt-2.5 cop-flex cop-items-center cop-gap-1 cop-text-[#cc0000]"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "Warning",
    className: "cop-h-3 cop-w-3"
  }), /*#__PURE__*/React.createElement(Base, {
    variant: "body",
    size: "base",
    leading: "normal",
    tag: "span",
    weight: "regular"
  }, error))));
};
